// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* API Settings: LLM configurations and their editor. The field, button and
   footer vocabulary is ../modal-content.module.css. */

.T2g51azmhRbaPgbWrCSl {
  margin: 0 0 18px;
  padding-bottom: 14px;
  border-bottom: 1px solid var(--curio-border);
}

.F4M1HXCVZTHDlV8jwNtu {
  margin: 0 0 6px;
  font-size: var(--curio-font-size-lg);
  font-weight: 600;
  color: var(--curio-text-primary);
}

.kK6jIvADkKZRf45Pymbw,
.zwi6cvEo8W9FK__4wh7v {
  margin: 0 0 10px;
  color: var(--curio-text-secondary);
  font-size: var(--curio-font-size-sm);
  line-height: 1.5;
}

.hcbD67bMwHy26vYIGAgI {
  margin: 0 0 10px;
  padding: 6px 10px;
  border-radius: var(--curio-radius-sm);
  background: var(--curio-page-bg);
  color: var(--curio-text-secondary);
  font-size: var(--curio-font-size-sm);
}

.R5M35ID_s2obnnYzdZHK {
  margin: 0 0 10px;
  color: var(--curio-text-primary);
  font-size: var(--curio-font-size-sm);
}

.PGo5Lvu8isIPMgcsV_qB,
.pozX9raW7gfR8mYbW0Tw {
  margin: 6px 0 10px;
  color: var(--curio-text-muted);
  font-size: var(--curio-font-size-sm);
}

.lbyAr9gjhTamkorBbt0_ {
  width: 100%;
  border-collapse: collapse;
  font-size: var(--curio-font-size-sm);
  margin-bottom: 8px;
}

.lbyAr9gjhTamkorBbt0_ caption {
  text-align: left;
  color: var(--curio-text-muted);
  font-size: var(--curio-font-size-sm);
  padding-bottom: 4px;
}

.lbyAr9gjhTamkorBbt0_ th,
.lbyAr9gjhTamkorBbt0_ td {
  text-align: left;
  vertical-align: top;
  padding: 5px 6px;
  border-bottom: 1px solid var(--curio-border);
}

.lbyAr9gjhTamkorBbt0_ th {
  font-weight: 600;
  color: var(--curio-text-secondary);
}

.Fea1XlkeqnqfPmg3saNe {
  font-weight: 600;
  color: var(--curio-text-primary);
}

.mVMC3kevcWsueJSHri_g {
  display: inline-block;
  margin-left: 6px;
  padding: 0 6px;
  border: 1px solid var(--curio-border-strong);
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
  color: var(--curio-text-secondary);
}

.V7lmMrnGZ2A0dORxpCQC {
  display: block;
  color: var(--curio-text-muted);
}

/* The buttons wrap onto another line, each keeping its label whole. A nowrap
   cell held "Edit Duplicate Remove" on one line, so the table was about
   451 px wide in a 409 px body and the modal scrolled sideways (#510). */
.NT2hgQU3Q5M9rbhJZkPy > .t0x6n3vY6DBj8bgs3Z7t {
  white-space: nowrap;
}

.t0x6n3vY6DBj8bgs3Z7t,
.CcPYTVBtCHdch1XMzuZX {
  padding: 0;
  margin-right: 10px;
  border: none;
  background: none;
  font: inherit;
  font-size: var(--curio-font-size-sm);
  color: var(--curio-text-secondary);
  text-decoration: underline;
  cursor: pointer;
}

.t0x6n3vY6DBj8bgs3Z7t:hover:not(:disabled),
.CcPYTVBtCHdch1XMzuZX:hover:not(:disabled) {
  color: var(--curio-text-primary);
}

.t0x6n3vY6DBj8bgs3Z7t:disabled,
.CcPYTVBtCHdch1XMzuZX:disabled {
  opacity: 0.6;
  cursor: default;
}

.CcPYTVBtCHdch1XMzuZX {
  align-self: flex-start;
  margin-top: 4px;
}

.hQtI878wwlRin06VwcO0 {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: center;
  white-space: normal;
}

.Y1j3sB5VD3udVum558aV {
  margin-top: 10px;
  padding: 12px;
  border: 1px solid var(--curio-border);
  border-radius: var(--curio-radius-md);
  background: var(--curio-card-bg);
}

.Cw_NDVnf7riFoddYm7vt {
  margin: 0 0 10px;
  font-size: var(--curio-font-size-md);
  font-weight: 600;
}

.ZyT6N6KeF0TrWu87WdQn {
  font-weight: 400;
  text-transform: none;
  color: var(--curio-text-muted);
  letter-spacing: 0;
}

/* Provider picker: a segmented row of choices, not a form field. */
.DcEx9pXmvPDk0Lwg5DrN {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}

.lRuWDtgVOlgo500vlt5F {
  padding: 6px 14px;
  border: 1px solid var(--curio-border-strong);
  border-radius: var(--curio-radius-md);
  background: var(--curio-card-bg);
  color: var(--curio-text-secondary);
  font: inherit;
  font-size: var(--curio-font-size-md);
  cursor: pointer;
}

.lRuWDtgVOlgo500vlt5F:hover:not(._UKuxaahE45082vF0XwH) {
  background: var(--curio-page-bg);
}

._UKuxaahE45082vF0XwH {
  border-color: var(--curio-top-bar-bg);
  background: var(--curio-top-bar-bg);
  color: var(--curio-text-on-dark);
  font-weight: 600;
}

.lq7eUUCTv_YCoQComrsQ {
  font-size: var(--curio-font-size-sm);
  color: var(--curio-role-published-fg);
  text-decoration: none;
  margin-top: 2px;
}

.SFPcv9OVcoCi9Twi69jM {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  margin-top: 6px;
}

.Lqtb27A5f7jkG7pRppKw {
  background: none;
  border: 1px solid var(--curio-border);
  border-radius: var(--curio-radius-sm);
  padding: 3px 10px;
  color: var(--curio-text-secondary);
  font-family: var(--curio-font-family);
  font-size: var(--curio-font-size-sm);
  cursor: pointer;
}

.Lqtb27A5f7jkG7pRppKw:hover:not(:disabled) {
  color: var(--curio-text-primary);
  border-color: var(--curio-text-secondary);
}

.Lqtb27A5f7jkG7pRppKw:disabled {
  opacity: 0.6;
  cursor: default;
}

.TP6vQUVFa_GYNGmoOJ4q {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 4px 0 8px;
  font-size: var(--curio-font-size-sm);
  color: var(--curio-text-secondary);
}

/* The Agent models row a card asked API Settings to open on. */
.a8bG9KV_2tQsCnneOuQP td {
  background: var(--curio-page-bg);
}
`, "",{"version":3,"sources":["webpack://./src/components/llmConfigs/LlmConfigs.module.css"],"names":[],"mappings":"AAAA;sDACsD;;AAEtD;EACE,gBAAgB;EAChB,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,oCAAoC;EACpC,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;;EAEE,gBAAgB;EAChB,kCAAkC;EAClC,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,qCAAqC;EACrC,gCAAgC;EAChC,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,oCAAoC;AACtC;;AAEA;;EAEE,kBAAkB;EAClB,8BAA8B;EAC9B,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;EACd,4CAA4C;EAC5C,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,8BAA8B;AAChC;;AAEA;;yEAEyE;AACzE;EACE,mBAAmB;AACrB;;AAEA;;EAEE,UAAU;EACV,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,oCAAoC;EACpC,kCAAkC;EAClC,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;;EAEE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,qCAAqC;EACrC,qCAAqC;EACrC,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA,mEAAmE;AACnE;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,4CAA4C;EAC5C,qCAAqC;EACrC,gCAAgC;EAChC,kCAAkC;EAClC,aAAa;EACb,oCAAoC;EACpC,eAAe;AACjB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,qCAAqC;EACrC,mCAAmC;EACnC,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;EACrC,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,qCAAqC;EACrC,iBAAiB;EACjB,kCAAkC;EAClC,qCAAqC;EACrC,oCAAoC;EACpC,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oCAAoC;EACpC,kCAAkC;AACpC;;AAEA,+DAA+D;AAC/D;EACE,gCAAgC;AAClC","sourcesContent":["/* API Settings: LLM configurations and their editor. The field, button and\n   footer vocabulary is ../modal-content.module.css. */\n\n.section {\n  margin: 0 0 18px;\n  padding-bottom: 14px;\n  border-bottom: 1px solid var(--curio-border);\n}\n\n.heading {\n  margin: 0 0 6px;\n  font-size: var(--curio-font-size-lg);\n  font-weight: 600;\n  color: var(--curio-text-primary);\n}\n\n.intro,\n.note {\n  margin: 0 0 10px;\n  color: var(--curio-text-secondary);\n  font-size: var(--curio-font-size-sm);\n  line-height: 1.5;\n}\n\n.shared {\n  margin: 0 0 10px;\n  padding: 6px 10px;\n  border-radius: var(--curio-radius-sm);\n  background: var(--curio-page-bg);\n  color: var(--curio-text-secondary);\n  font-size: var(--curio-font-size-sm);\n}\n\n.active {\n  margin: 0 0 10px;\n  color: var(--curio-text-primary);\n  font-size: var(--curio-font-size-sm);\n}\n\n.skeleton,\n.empty {\n  margin: 6px 0 10px;\n  color: var(--curio-text-muted);\n  font-size: var(--curio-font-size-sm);\n}\n\n.table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: var(--curio-font-size-sm);\n  margin-bottom: 8px;\n}\n\n.table caption {\n  text-align: left;\n  color: var(--curio-text-muted);\n  font-size: var(--curio-font-size-sm);\n  padding-bottom: 4px;\n}\n\n.table th,\n.table td {\n  text-align: left;\n  vertical-align: top;\n  padding: 5px 6px;\n  border-bottom: 1px solid var(--curio-border);\n}\n\n.table th {\n  font-weight: 600;\n  color: var(--curio-text-secondary);\n}\n\n.name {\n  font-weight: 600;\n  color: var(--curio-text-primary);\n}\n\n.badge {\n  display: inline-block;\n  margin-left: 6px;\n  padding: 0 6px;\n  border: 1px solid var(--curio-border-strong);\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--curio-text-secondary);\n}\n\n.host {\n  display: block;\n  color: var(--curio-text-muted);\n}\n\n/* The buttons wrap onto another line, each keeping its label whole. A nowrap\n   cell held \"Edit Duplicate Remove\" on one line, so the table was about\n   451 px wide in a 409 px body and the modal scrolled sideways (#510). */\n.actions > .actionBtn {\n  white-space: nowrap;\n}\n\n.actionBtn,\n.quietBtn {\n  padding: 0;\n  margin-right: 10px;\n  border: none;\n  background: none;\n  font: inherit;\n  font-size: var(--curio-font-size-sm);\n  color: var(--curio-text-secondary);\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.actionBtn:hover:not(:disabled),\n.quietBtn:hover:not(:disabled) {\n  color: var(--curio-text-primary);\n}\n\n.actionBtn:disabled,\n.quietBtn:disabled {\n  opacity: 0.6;\n  cursor: default;\n}\n\n.quietBtn {\n  align-self: flex-start;\n  margin-top: 4px;\n}\n\n.confirm {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  align-items: center;\n  white-space: normal;\n}\n\n.editor {\n  margin-top: 10px;\n  padding: 12px;\n  border: 1px solid var(--curio-border);\n  border-radius: var(--curio-radius-md);\n  background: var(--curio-card-bg);\n}\n\n.editorTitle {\n  margin: 0 0 10px;\n  font-size: var(--curio-font-size-md);\n  font-weight: 600;\n}\n\n.optional {\n  font-weight: 400;\n  text-transform: none;\n  color: var(--curio-text-muted);\n  letter-spacing: 0;\n}\n\n/* Provider picker: a segmented row of choices, not a form field. */\n.modeTabs {\n  display: flex;\n  gap: 6px;\n  flex-wrap: wrap;\n}\n\n.modeTab {\n  padding: 6px 14px;\n  border: 1px solid var(--curio-border-strong);\n  border-radius: var(--curio-radius-md);\n  background: var(--curio-card-bg);\n  color: var(--curio-text-secondary);\n  font: inherit;\n  font-size: var(--curio-font-size-md);\n  cursor: pointer;\n}\n\n.modeTab:hover:not(.modeTabActive) {\n  background: var(--curio-page-bg);\n}\n\n.modeTabActive {\n  border-color: var(--curio-top-bar-bg);\n  background: var(--curio-top-bar-bg);\n  color: var(--curio-text-on-dark);\n  font-weight: 600;\n}\n\n.keyLink {\n  font-size: var(--curio-font-size-sm);\n  color: var(--curio-role-published-fg);\n  text-decoration: none;\n  margin-top: 2px;\n}\n\n.modelFetchRow {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n  margin-top: 6px;\n}\n\n.fetchModelsBtn {\n  background: none;\n  border: 1px solid var(--curio-border);\n  border-radius: var(--curio-radius-sm);\n  padding: 3px 10px;\n  color: var(--curio-text-secondary);\n  font-family: var(--curio-font-family);\n  font-size: var(--curio-font-size-sm);\n  cursor: pointer;\n}\n\n.fetchModelsBtn:hover:not(:disabled) {\n  color: var(--curio-text-primary);\n  border-color: var(--curio-text-secondary);\n}\n\n.fetchModelsBtn:disabled {\n  opacity: 0.6;\n  cursor: default;\n}\n\n.checkRow {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin: 4px 0 8px;\n  font-size: var(--curio-font-size-sm);\n  color: var(--curio-text-secondary);\n}\n\n/* The Agent models row a card asked API Settings to open on. */\n.focusedRow td {\n  background: var(--curio-page-bg);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"section": `T2g51azmhRbaPgbWrCSl`,
	"heading": `F4M1HXCVZTHDlV8jwNtu`,
	"intro": `kK6jIvADkKZRf45Pymbw`,
	"note": `zwi6cvEo8W9FK__4wh7v`,
	"shared": `hcbD67bMwHy26vYIGAgI`,
	"active": `R5M35ID_s2obnnYzdZHK`,
	"skeleton": `PGo5Lvu8isIPMgcsV_qB`,
	"empty": `pozX9raW7gfR8mYbW0Tw`,
	"table": `lbyAr9gjhTamkorBbt0_`,
	"name": `Fea1XlkeqnqfPmg3saNe`,
	"badge": `mVMC3kevcWsueJSHri_g`,
	"host": `V7lmMrnGZ2A0dORxpCQC`,
	"actions": `NT2hgQU3Q5M9rbhJZkPy`,
	"actionBtn": `t0x6n3vY6DBj8bgs3Z7t`,
	"quietBtn": `CcPYTVBtCHdch1XMzuZX`,
	"confirm": `hQtI878wwlRin06VwcO0`,
	"editor": `Y1j3sB5VD3udVum558aV`,
	"editorTitle": `Cw_NDVnf7riFoddYm7vt`,
	"optional": `ZyT6N6KeF0TrWu87WdQn`,
	"modeTabs": `DcEx9pXmvPDk0Lwg5DrN`,
	"modeTab": `lRuWDtgVOlgo500vlt5F`,
	"modeTabActive": `_UKuxaahE45082vF0XwH`,
	"keyLink": `lq7eUUCTv_YCoQComrsQ`,
	"modelFetchRow": `SFPcv9OVcoCi9Twi69jM`,
	"fetchModelsBtn": `Lqtb27A5f7jkG7pRppKw`,
	"checkRow": `TP6vQUVFa_GYNGmoOJ4q`,
	"focusedRow": `a8bG9KV_2tQsCnneOuQP`
};
export default ___CSS_LOADER_EXPORT___;
